import React, { Component } from "react";
import "../assets/css/DonationComponent.css";
import "../assets/css/responsive.css";
import StripeContainer from "./StripeContainer";
import Spinner from "../Spinner";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "./Navbar"
import Footer from "./Footer";
import ThankYouPage from "./ThankYouPage"
import BlueSection from "./BlueSection"
import { ReactComponent as BackgroundSVG } from "../assets/img/background.svg";

class BookCampaignComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      currentURL: "",
      hasDonated: false,
      amount: 100,
      payFees: false,
      firstName: ""
    };
  }

  updateIsLoading = (state) => {
    this.setState({ isLoading: state });
  };

  updateHasDonated = (state) => {
    this.setState({ hasDonated: state });
  };


  updateAmount = (amount) => {
    this.setState({ amount: amount });
  };

  togglePayFees = (e) => {
    this.setState({ payFees: !this.state.payFees });
  };

  componentDidMount() {
    this.setState({ currentURL: window.location.href });
  }

  updateFirstName = (firstName) => {
    this.setState({firstName: firstName})
  }

  render() {
    return (
      <>
      <BlueSection />
        <div className="donation-area book-donation bg-gray default-padding">
          {/* Fixed BG */}
          <Navbar />
          <div
            className={
              this.state.currentURL.includes("monthly")
                ? "fixed-bg monthly"
                : "fixed-bg"
            }
            id="bg-wrap"
          ><BackgroundSVG /></div>
          {/* End Fixed BG */}
          <div className="container">
            <div className="row mt-5">
            <div className="col-lg-6 order-2 order-lg-1 info">
                <form className="book-form-element">
                  <div className="col-lg-12" style={{textAlign: "center"}}>
                    <img
                      src="/book.png"
                      alt="Image description"
                      style={{
                        maxWidth: "100%",
                        height: "auto"
                      }}
                    />
                  </div>
                </form>
              </div>
              <div className="col-lg-6 order-1 order-lg-2 info text-light donation-form">
                {this.state.hasDonated ? <ThankYouPage amount={this.state.amount} 
                updateHasDonated={this.updateHasDonated} firstName={this.state.firstName}  /> : (
                  <StripeContainer updateIsLoading={this.updateIsLoading} 
                  updateHasDonated={this.updateHasDonated} 
                  amount={this.state.amount}  
                  updateAmount={this.updateAmount}
                  payFees={this.state.payFees}
                  togglePayFees={this.togglePayFees}
                  updateFirstName={this.updateFirstName}
                  formType="Book"
                  />
                )}
                
              </div>
            </div>
          </div>
        </div>
        {this.state.isLoading && <Spinner />}
        <ToastContainer />
        <Footer />
      </>
    );
  }
}

export default BookCampaignComponent;